import GraphMenuComponent from '../component/graphmenu.component';
import { useState, useEffect, useRef } from 'react';
import useHttpApiCall from '../../../services/useHttpApiCall';

import { useParams, useNavigate } from 'react-router-dom';

import { customWidgetEndpointLayers } from '../../../config/widgetEndpoints';

import { COMPONENT_MAP, createChartConfig } from '../utils/renderGraph.util';
//

export default function SelectGraphContainer({
  setOpenSelectGraphSlider}) {
  const [showToast, setShowToast] = useState({ show: false, variant: 'success' });
  const [payload, setPayload] = useState(undefined);
  const [data] = useHttpApiCall(payload);
  const [availableGraphs, setAvailableGraphs] = useState([]);
  const [selectedGraphs, setSelectedGraphs] = useState([]);
  const [dashboardName, setDashboardName] = useState('');
  const navigate = useNavigate();

  const { id } = useParams();
  const pathSegments = window.location.pathname.split('/');
  // const dashboardId = pathSegments.pop(); // Gets the ID
  const isEditMode = pathSegments.includes('viewDashboardList');

  // isEditMode should be true only if it's not view mode and has a valid ID
  //const isEditMode = id!= null ;

  //console.log('isEditMode', isEditMode);
  const chartRefs = useRef({});

  const getChartRef = (id) => {
    if (!chartRefs.current[id]) {
      chartRefs.current[id] = { current: null };
    }
    return chartRefs.current[id];
  };

  useEffect(() => {
    let url = 'v0/my-dashboard/select-graph/';
    if (isEditMode) {
      url += `?show_selected=1&dashboard_id=${id}`;
    }
    setPayload({
      method: 'GET',
      auth: true,
      url: url
    });
  }, [id]);

  useEffect(() => {
    if (data?.data?.data) {
      const response = data?.data?.data;
      setDashboardName(data?.data?.dashboard_name || '');
      // console.log("response",  data?.data?.dashboard_name)
      const transformed = [];
      const preselected = [];

      Object.entries(response).forEach(([layerType, layers]) => {
        if (Array.isArray(layers)) {
          layers.forEach((layer) => {
            const processGraphArray = (array, category) => {
              if (!array) return;

              const processedGraphs = array
                .filter((g) => g.name)
                .map((g) => {
                  const graphObj = {
                    id: g.graph_identifier,
                    name: g.name,
                    queryParams: g.query_params,
                    layerId: layer.layer_id || g.layer_id,
                    plantCode: layer.plant_code || g.plant_code,
                    layerTypes: layer.layer_type || g.layer_type,
                    isActive: g.is_active,
                    graphType: g.graph_type,
                    graphOrder: g.graph_order,
                    graphTemplate: g.graph_template,
                    aq_index: g.aq_index,
                    sensor_type: g.sensor_type,
                    kpi_id: g.kpi_id,
                    graph_list_name: g.graph_list_name,

                    category,
                    ...(category === 'equipment_kpi' && {
                      kpi_id: g.kpi_id,
                      kpi_unit: g.kpi_unit_id,
                      kpi_name: g.kpi_name
                    })
                  };

                  // Auto-select if is_graph_selected is true
                  if (g.is_graph_selected) {
                    const { component, config, ref } = getComponentForGraph(graphObj);
                    if (component) {
                      preselected.push({
                        id: graphObj.id,
                        name: graphObj.name,
                        component,
                        config,
                        ref,
                        category: graphObj.category
                      });
                    }
                  }

                  return graphObj;
                });

              transformed.push({
                layer_type: layer.layer_type || layerType,
                name: layer.name,
                graphs: processedGraphs
              });
              //console.log("transformed", transformed)
            };

            processGraphArray(layer.graphs, 'graph');
            processGraphArray(layer.machine_status, 'machine_status');
            processGraphArray(layer.equipment_kpi, 'equipment_kpi');
          });
        }
      });

      setAvailableGraphs(transformed);
      setSelectedGraphs(preselected);
    }
  }, [data]);


  const getComponentForGraph = (graph) => {
    // Handle special cases first
    // console.log('graph', graph);
    if (graph.category === 'graph' && graph.graphType == 'sensor_addon_summary') {
      return {
        component: COMPONENT_MAP.CustomTotalEnergyUseContainer,
        config: {
          drilldownlevel: 'Machine',
          layer_id: graph?.layerId || 1,
          plant_code: graph.plantCode,
          layer_type: graph.layerTypes,
          graph_name: graph.name,
          graph_type: graph.graphType,
          graph_order: graph.graphOrder,
          is_Active: graph.isActive,
          sensor_type: graph.sensor_type,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          customGraphApi: customWidgetEndpointLayers.energyUseSummary,
          flexibleEquipmentEnabled: true
        },
        ref: getChartRef(graph.id)
      };
    }
    if (graph.category === 'graph' && graph.graphType ==='sensor_addon_timeseries') {
      return {
        component: COMPONENT_MAP.CustomPowerUsageContainer,
        config: {
          drilldownlevel: 'Machine',
          graph_name: graph.name,
          layer_type: graph.layerTypes,
          layer_id: graph.layerId,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          plant_code: graph.plantCode,
          sensor_type: graph.sensor_type,
          customGraphApi:
            graph?.layerTypes === 'water_flow'
              ? customWidgetEndpointLayers.waterflow
              : customWidgetEndpointLayers.layeredPowerUsage,
          flexibleEquipmentEnabled: true
        },
        ref: getChartRef(graph.id)
      };
    }
    //water flow
      if (graph.category === 'graph' && graph.graphType === 'sensor_addon_summary_v1') {
       // console.log("sensor_addon_summary_v1", graph)
      return {
        component: COMPONENT_MAP.waterflowTotalEnergyUseContainer,
        config: {
          drilldownlevel: 'airSummary',
          layer_id: graph?.layerId || 1,
          plant_code: graph.plantCode,
          layer_type: graph.layerTypes,
          graph_name: graph.name,
          graph_type: graph.graphType,
          graph_order: graph.graphOrder,
          is_Active: graph.isActive,
          sensor_type: graph.sensor_type,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          customGraphApi: customWidgetEndpointLayers.airflowEnergyUseSummary,
          flexibleEquipmentEnabled: true
        },
        ref: getChartRef(graph.id)
      };
    }
      if (graph.category === 'graph' && graph.graphType === 'sensor_addon_timeseries_v1') {
        //console.log("checkkkkkkkk",graph)
        return {
        component: COMPONENT_MAP.CustomPressureContainer,
        config: {
          drilldownlevel: 'Home',
          graph_name: graph.name,
          layer_type: graph.layerTypes,
          layer_id: graph.layerId,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          plant_code: graph.plantCode,
          sensor_type: graph.sensor_type,
          customGraphApi:customWidgetEndpointLayers.waterflow,
          flexibleEquipmentEnabled: true
        },
        ref: getChartRef(graph.id)
      };
    }
   if (graph.category === 'graph' && graph.graphType === 'air_flow') {
      return {
        component: COMPONENT_MAP.CustomPressureContainer,
        config: {
          drilldownlevel: 'Home',
          graph_name: graph.name,
          layer_type: graph.layerTypes,
          layer_id: graph.layerId,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          plant_code: graph.plantCode,
          sensor_type: graph.sensor_type,
          customGraphApi:customWidgetEndpointLayers.airflow,
          flexibleEquipmentEnabled: true
        },
        ref: getChartRef(graph.id)
      };
    }
    if (
      graph.category === 'graph' &&
      ['aq_pm1', 'aq_co2', 'aq_voc', 'aq_pm2_5', 'aq_pm4', 'aq_pm10'].includes(graph.graphType)
    ) {
      //console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh');

      return {
        component: COMPONENT_MAP.CustomAirQualityContainer,
        config: {
          drilldownlevel: 'Machine',
          layer_id: graph?.layerId || 1,
          plant_code: graph.plantCode,
          layer_type: graph.layerTypes,
          graph_name: graph.name,
          graph_type: graph.graphType,
          graph_order: graph.graphOrder,
          is_Active: graph.isActive,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          aq_index: graph.aq_index,
          slug: 'aq_pm1', // Consider setting this dynamically if needed
          customGraphApi: customWidgetEndpointLayers.energyUseSummary
        },
        ref: getChartRef(graph.id)
      };
    }

    if (graph.category === 'graph' && ['temperature', 'humidity'].includes(graph.graphType)) {
      //  console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh');

      return {
        component: COMPONENT_MAP.CustomTimeSeriesContainer,
        config: {
          drilldownlevel: 'Home',
          graph_name: graph.name,
          plant_code: graph.plantCode,
          layer_type: graph.layerTypes,
          layer_id: graph.layerid,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          sensor_type: graph.sensor_type
        },
        ref: getChartRef(graph.id)
      };
    }
    if (graph.category === 'graph' && graph.graphType == 'company_kpi') {
      return {
        component: COMPONENT_MAP.KpiOneContainer,
        config: {
          drilldownlevel: 'Machine',
          graph_name: graph.name,
          layer_type: graph.layerTypes,
          query_params: graph.queryParams,
          graph_template: graph.graphTemplate,
          layer_id: graph.layerId,
          plant_code: graph.plantCode,
          kpi_id: graph.kpi_id
        },
        ref: getChartRef(graph.id)
      };
    }

    if (graph.category === 'machine_status') {
      const drilldownlevel =
        graph.layerTypes === 'component'
          ? 'ComponentLayer'
          : graph.layerTypes === 'process'
          ? 'ProcessLayer'
          : graph.layerTypes === 'equipment'
          ? 'EquipmentLayer'
          : graph.layerTypes === 'machine'
          ? 'Machine'
          : graph.layerTypes === 'plant'
          ? 'Plant'
          : '';

      return {
        component: COMPONENT_MAP.machineStatus,
        config: {
          processDetails: {
            drilldownlevel,
            layer_id: graph.layerId,
            plant_code: graph.plantCode,
            layer_type: graph.layerTypes,
            graph_name: graph.name,
            graph_type: graph.graphType,
            graph_order: graph.graphOrder,
            is_Active: graph.isActive,
            query_params: graph.queryParams,
            graph_template: graph.graphTemplate,
            isNewDashboard: true
          }
        },
        ref: getChartRef(graph.id)
      };
    }

    if (graph.category === 'equipment_kpi') {
      return {
        component: COMPONENT_MAP.kpi,
        config: {
          processDetails: {
            drilldownlevel: 'selectGraphLayer',
            layer_id: graph.layerId,
            plant_code: graph.plantCode,
            layer_type: graph.layerTypes,
            graph_name: graph.name,
            graph_type: graph.graphType,
            graph_order: graph.graphOrder,
            is_Active: graph.isActive,
            kpi_unit: graph.kpi_unit,
            kpi_id: graph.kpi_id,
            graph_template: graph.graphTemplate,
            selectedGraphNames: graph.kpi_name,
            query_params: graph.queryParams,
            isNewDashboard: true
          }
        },
        ref: getChartRef(graph.id)
      };
    }

    let chartType;
    const lowerName = graph.name.toLowerCase();
    if (lowerName.includes('total energy')) {
      chartType = 'totalEnergy';
    } else if (lowerName.includes('process energy')) {
      chartType = 'processEnergy';
    } else if (
      lowerName.includes('equipment instantaneous') ||
      lowerName.includes('equipment power')
    ) {
      chartType = 'equipmentInstantaneousPower';
    } else if (lowerName.includes('instantaneous') || lowerName.includes('power')) {
      chartType = 'instantaneousPower';
    }

    const level =
      graph.layerTypes === 'component'
        ? 'ComponentLayer'
        : graph.layerTypes === 'process'
        ? 'ProcessLayer'
        : graph.layerTypes === 'equipment'
        ? 'EquipmentLayer'
        : graph.layerTypes === 'machine'
        ? 'Machine'
        : graph.layerTypes === 'plant'
        ? 'Plant'
        : 'Company';

    return {
      component: COMPONENT_MAP[chartType],
      config: createChartConfig(chartType, level, {
        layer_id: graph.layerId,
        plant_code: graph.plantCode,
        graph_name: graph.name,
        layer_type: graph.layerTypes,
        graph_type: graph.graphType,
        graph_order: graph.graphOrder,
        graph_template: graph.graphTemplate,
        is_Active: graph.isActive,
        query_params: graph.queryParams
      }),
      ref: getChartRef(graph.id)
    };
  };

  const handleAddGraphToDashboard = (graph) => {
    const { component, config, ref } = getComponentForGraph(graph);

    if (!component) {
      console.log('not component');
      setShowToast({
        show: true,
        variant: 'danger',
        message: `Graph "${graph.name}" cannot be added - component not available.`
      });
      return;
    }

    setSelectedGraphs((prev) => {
      if (prev.some((g) => g.id === graph.id)) return prev;
      return [
        ...prev,
        {
          id: graph.id,
          name: graph.name,
          component,
          config,
          ref,
          category: graph.category
        }
      ];
    });
    //console.log('handleGraph', selectedGraphs);
  };

  const removeGraphFromDashboard = (graphId) => {
    setSelectedGraphs((prev) => prev.filter((g) => g.id !== graphId));
  };

  const handleClose = () => {
    if (setOpenSelectGraphSlider) {
      // Reset the state FIRST
      setSelectedGraphs([]);

      // Then close the slider after a small delay to ensure state update is processed
      setTimeout(() => {
        setOpenSelectGraphSlider(false);
      }, 50);
    } else {
      navigate(-1);
    }
  };


  return (
    <GraphMenuComponent
      setShowToast={setShowToast}
      showToast={showToast}
      handleClose={handleClose}
      availableGraphs={availableGraphs}
      selectedGraphs={selectedGraphs}
      handleAddGraphToDashboard={handleAddGraphToDashboard}
      removeGraphFromDashboard={removeGraphFromDashboard}
      dashboardName={dashboardName}
    />
  );
}
